<template>
  <input type="text"
         class="form-control"
         v-model="cadastreNumberModel"
         :class="{invalid: invalid}"
         @input="handleInput"
         @change="handleInput"
         :disabled="disabled"
         :readonly="readonly"
  />
</template>

<script>
import {cadastreFormat} from "@/shared/cadastre-format";

export default {
  name: "CadastreInput",
  props: {
    cadastreNumber: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      cadastreNumberModel: this.$props.cadastreNumber
    }
  },
  methods: {
    handleInput(event) {
      if(event && event.target && event.target.value) {
        this.cadastreNumberModel = cadastreFormat(event.target.value, this.$props.maxLength)
        this.$emit("update:cadastre-number", this.cadastreNumberModel)
      }

    }
  },
  watch: {
    cadastreNumber: {
      handler: function (val) {
        this.cadastreNumberModel = val
      }
    }
  }
}
</script>

<style scoped>

</style>
